<template>
  <div class="h-full px-4 pb-6">
    <div v-if="loaded && dataAvailable"  class="h-full -ml-1.5 ">

      <div class="flex ml-2 pb-[8.8rem] -mt-[0.3rem]  w-fit flex-col h-full absolute justify-around  ">
        <p class=" text-sm 	truncate text-gray-600	w-[17rem] " v-for="currentLabel in currentLabels" :key="currentLabel.id"> {{currentLabel}}</p>
      </div>
      <bar-chart class="absolute h-full mt-3 pb-20" ref="chart" :isCurrency="isCurrency" :source="source" :style="style" :colorPalette="colorPalette" :labels="currentLabels" :treeLabels="currentTreeLabels" :values="currentAmounts" :subject="subject" :type="type"></bar-chart>

    </div>
<!--    <div v-if="!loaded" class="flex h-full items-center justify-center">-->
<!--      <div class="loader loader&#45;&#45;style3">-->
<!--        <svg id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="80px" height="80px" viewBox="0 0 50 50"  xml:space="preserve">-->
<!--          <path class="loadingSpinner h-20" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">-->
<!--            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/>-->
<!--            </path>-->
<!--          </svg>-->
<!--      </div>-->
<!--    </div>-->
    <div v-show="!dataAvailable && loaded" class="h-full flex justify-center">
      <p  v-if="filter === 'orders'" class="self-center  text-center -mt-14">{{ $t('widget.noDataForPill', {pill: $t('widget.filters.orders').toLowerCase()}) }}</p>
      <p  v-if="filter === 'sales'" class="self-center  text-center -mt-14">{{ $t('widget.noDataForPill', {pill: $t('widget.filters.sales').toLowerCase()}) }}</p>
      <p  v-if="filter === 'views'" class="self-center  text-center -mt-14">{{ $t('widget.noDataForPill', {pill: $t('widget.filters.views').toLowerCase()}) }}</p>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch, defineEmits} from "vue";
import BarChart from "@/widgetContent/charts/BarChart";
import ApiService from "@/services/ApiService";
let apiService = new ApiService;
let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})
let data = ref(Object);
let loaded = ref(false);
let chart = ref(null);

let currentLabels = ref([]);
let currentAmounts = ref([]);
let amount = ref([]);
let currentTreeLabels = ref([]);
let filter =ref();
let barColor = ref('');
let isCurrency = ref(false);
let dataAvailable = ref();
const emit = defineEmits(["dataLoaded", "dataUnloaded"])
let subject = ref("");
onMounted ( async () => {
  await getData(props.source)
  }
)

async function getData(url) {
  loaded.value = false;
  let apiData = await apiService.get(url).then((response) => {
    return response;
  });
  filter.value =  url.substring(url.lastIndexOf('/')+1);
  props.pills.forEach( entry=> {
    if (filter.value === entry.source.substring(entry.source.lastIndexOf('/')+1)){
      subject.value = entry.label.toLowerCase()
    }
  })
  emit("dataLoaded")
  data.value = apiData.data
  currentLabels.value = []
  currentTreeLabels.value = []
  currentAmounts.value = []
  amount.value = []
  if (data.value.length > 0){
    dataAvailable.value = true
    data.value.forEach(category => {
      currentLabels.value.push(category.label);
      currentTreeLabels.value.push(category.treeLabels);
      amount.value.push(category.amount);
    })
    currentAmounts.value = amount.value
    barColor.value = props.colorPalette.barGraphPrimary
  }else {
    dataAvailable.value = false;
  }
  loaded.value = true;
}


watch(() => [props.update,props.source], () => {
  refreshData();
})

function refreshData()
{
  isCurrency.value = props.source.slice(-5) === "sales";
  getData(props.source)
}
</script>

